import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const defaultOptions = {
  automaticLayout: true,
  contextmenu: false,
  fontFamily: token('font.family.code'),
  fontSize: 13,
  hideCursorInOverviewRuler: true,
  hover: false,
  lineDecorationsWidth: gridSize(),
  // the gutter only really fits N-1 characters due to `lineDecorationsWidth`
  lineNumbersMinChars: 6,
  matchBrackets: false,
  minimap: { enabled: false },
  occurrencesHighlight: false,
  // required even though the docs say it defaults to `false`
  renderIndentGuides: false,
  renderLineHighlight: 'none',
  scrollBeyondLastLine: false,
  selectionHighlight: false,
  // we handle this ourselves
  selectOnLineNumbers: false,
};

export const editorOptions = {
  readOnly: false,
};

export const readOnlyOptions = {
  readOnly: true,
};
